import { useState } from 'react'
import { Sticky } from 'semantic-ui-react'
import { SignupHeaderLogic } from './SignupHeader'
import { TypographyStyles } from '@/styles'
import { Alert, Button, Image, Text } from '@/ui'

const rootElement = document.getElementById('root')

export const MobileHeader = ({
  loggedIn,
  handleLogoutClick,
  currentStep,
  reactivating,
  hideProgress,
}: {
  loggedIn: boolean
  handleLogoutClick: () => void
  currentStep: number
  reactivating: boolean
  hideProgress?: boolean
}) => {
  const [isStuck, setIsStuck] = useState(false)

  return (
    <>
      <div className="flex items-center justify-between pb-0">
        <div className="w-7/8">
          <Image
            src="https://heard-images.s3.us-west-1.amazonaws.com/heard_logo_green_2x.png"
            alt="heard logo"
            height={20}
            width={20}
          />

          {loggedIn && (
            <Button
              className="float-right"
              variant="link"
              onClick={() => handleLogoutClick()}
            >
              Logout
            </Button>
          )}
        </div>
      </div>

      {!hideProgress && (
        <div className="min-h-fit">
          <div className={isStuck ? 'p-0' : undefined}>
            <Sticky
              offset={14}
              context={rootElement}
              onStick={() => setIsStuck(true)}
              onUnstick={() => setIsStuck(false)}
              className={
                isStuck ? 'bg-white shadow-md px-4 -m-4 w-full' : undefined
              }
            >
              <SignupHeaderLogic currentStep={currentStep} />
            </Sticky>
          </div>
        </div>
      )}

      {reactivating && (
        <Alert>
          <Text variant={TypographyStyles.BODY_LG}>Welcome back to Heard!</Text>

          <Text variant={TypographyStyles.BODY_LG}>
            To reactivate your account, please proceed through the sign up flow.
          </Text>
        </Alert>
      )}
    </>
  )
}
